import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {DraftMessageModel, MessageVisualStatusesEnum} from '../../../../../models/api/messageModel';
import {AppState} from '../../../../../store/appState';
import {getCompanyUrl} from '../../../../../store/data/company/companySelectors';
import {getMessages} from '../../../../../store/data/dataSelectors';
import {makeGetAuthor} from '../../../../../store/data/messages/messagesSelectors';
import {DraftAssistantDropdown} from './draftAssistantDropdown';

/*
 * Props.
 */

interface DraftAssistantDropdownContainerProps {
  conversation: ConversationModel | null;
  draftMessage: DraftMessageModel;
}

/*
 * Selectors.
 */

function getDraftMessage(_state: AppState, props: DraftAssistantDropdownContainerProps) {
  return props.draftMessage;
}

function getPreviousMessageUid(_state: AppState, props: DraftAssistantDropdownContainerProps) {
  if (!props.conversation) {
    return null;
  }

  const {lastMessage} = props.conversation;
  return lastMessage ? lastMessage.uid : null;
}

const getPreviousMessage = createSelector(
  [getPreviousMessageUid, getMessages],
  (previousMessageUid, messages) => {
    const message = previousMessageUid && messages[previousMessageUid];
    if (!message || message.visualStatus !== MessageVisualStatusesEnum.TIMELINE) {
      return null;
    }
    return message;
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DraftAssistantDropdownContainerProps>()(() => ({
  previousMessage: getPreviousMessage,
  author: makeGetAuthor(getDraftMessage),
  companyUrl: getCompanyUrl,
}));

export const DraftAssistantDropdownContainer = connect(mapStateToProps)(DraftAssistantDropdown);
